import { render, staticRenderFns } from "./MisMaterias.vue?vue&type=template&id=1bede36d"
import script from "./MisMaterias.vue?vue&type=script&lang=js"
export * from "./MisMaterias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports